import React from 'react';
import { agentDetails, availableAgents } from '../../../mocks/agents';
import { Button } from '../../../components/base/Button';

interface AgentDetailsSectionProps {
  selectedAgentId: string;
}

export const AgentDetailsSection: React.FC<AgentDetailsSectionProps> = ({ selectedAgentId }) => {
  const agent = availableAgents.find(a => a.id === selectedAgentId);
  const details = agentDetails[selectedAgentId];

  if (!agent || !details) return null;

  const scrollToDemo = () => {
    const element = document.getElementById('demo-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="agent-details" className="py-32 bg-dark">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="flex items-center gap-4 mb-8">
              <div className="w-20 h-20 rounded-full overflow-hidden shadow-lg shadow-primary/20 flex-shrink-0">
                <img 
                  src={agent.image} 
                  alt={agent.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h2 className="text-4xl font-display font-semibold text-white">
                  {agent.name}
                </h2>
                <p className="text-base text-white mt-1">{agent.role}</p>
              </div>
            </div>

            <h3 className="text-3xl font-display font-semibold text-white mb-8">
              {details.title}
            </h3>
            
            <div className="space-y-8">
              {details.capabilities.map((capability, index) => (
                <div key={index} className="flex gap-6">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-gradient-to-br from-primary to-primary-dark rounded-2xl shadow-lg shadow-primary/20">
                    <i className={`${capability.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-display font-semibold text-white mb-2">
                      {capability.title}
                    </h4>
                    <p className="text-base text-white leading-relaxed">
                      {capability.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="lg:sticky lg:top-24">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 border-2 border-gray-700 rounded-3xl p-10 shadow-xl">
              <h3 className="text-2xl font-display font-semibold text-white mb-6">
                Qué obtienes con {agent.name}
              </h3>
              
              <div className="space-y-4 mb-8">
                {details.benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-lg text-primary"></i>
                    </div>
                    <span className="text-sm text-white">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="bg-gradient-to-br from-primary/10 to-secondary/10 border border-primary/30 rounded-2xl p-6 mb-8">
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-flash-line text-2xl text-primary"></i>
                  </div>
                  <h4 className="text-base font-display font-semibold text-white">
                    Valor para tu negocio
                  </h4>
                </div>
                <p className="text-sm text-white leading-relaxed">
                  {agent.valueProposition}
                </p>
              </div>
              
              <Button 
                variant="primary" 
                size="lg"
                onClick={scrollToDemo}
              >
                Agenda tu demo personalizada
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}